import * as Yup from "yup";
import * as moment from "moment";
import { FORMAT } from "./dateOfBirthValidation";

export function getPostInitialValues(editResponse){
  let equipment0=false
  let equipment1=false
  let equipment2=false
  for (let j = 0; j < editResponse?.equipmentRequirements.length; j++) {
    if (editResponse?.equipmentRequirements[j] === "FLAT_BED") {
      equipment0=true
    } if (editResponse?.equipmentRequirements[j] === "ENCLOSED_TRAILER") {
      equipment1=true
    } if (editResponse?.equipmentRequirements[j] === "STRAIGHT_TRUCK") {
      equipment2=true
    }
  }

  let condition0=false
  let condition1=false
  let condition2=false
  for (let p = 0; p < editResponse?.palletDetails?.condition.length; p++) {
    if (editResponse?.palletDetails?.condition[p] === "RECYCLED") {
      condition0=true
    } if (editResponse?.palletDetails?.condition[p] === "NEW") {
      condition1=true
    } if (editResponse?.palletDetails?.condition[p] === "COMBO") {
      condition2=true
    }
  }
  

  let palletType = editResponse?.palletDetails?.palletType?.toLowerCase()
    if (palletType === "euro" || editResponse?.palletDetails?.palletType === "EUROPALLET") {
      palletType = "euroPallet"
    }
  let requestDeliveryDate = moment(new Date().setDate(new Date().getDate() + 4)).format(FORMAT)
  // if(editResponse && editResponse?.data?.loadDetails.requestDeliveryDate){
  //   requestDeliveryDate = moment(new Date(editResponse?.data.loadDetails.requestDeliveryDate * 1000).toLocaleString()).format(FORMAT)
  // }
  let loadDetailsRequestDeliveryDate
  if(editResponse?.loadDetails?.requestDeliveryDate){
    loadDetailsRequestDeliveryDate = moment(editResponse.loadDetails.requestDeliveryDate).format(FORMAT)
  }

  let currentTimeBegin = new Date()
  currentTimeBegin.setHours(8)
  currentTimeBegin.setMinutes(0)

  let beginHours = currentTimeBegin.getHours();
  let beginMinutes = currentTimeBegin.getMinutes()
  if(beginHours <=9){
    beginHours= "0"+beginHours
  }
  if(beginMinutes.length <=9 || beginMinutes === 0){
    beginMinutes= beginMinutes+"0"
  }
  // let beginCurrentTime = beginHours + ':' + beginMinutes
  let beginCurrentTime = '00:00'
  let currentTimeEnd = new Date()
  currentTimeEnd.setHours(17)
  currentTimeEnd.setMinutes(0)

  if(editResponse?.loadDetails?.deliveryFromtime){
    beginCurrentTime= editResponse?.loadDetails.deliveryFromtime
  }

  let endCurrentTime = "23:00"

  if(editResponse?.loadDetails?.deliveryTotime){
    endCurrentTime= editResponse?.loadDetails.deliveryTotime
  }

  let recurrenceObjValues
  if(editResponse?.recurrence) recurrenceObjValues = editResponse?.recurrence

  let requestStartDateRecOrder = moment(new Date().setDate(new Date().getDate() + 2)).format(FORMAT)
  let requestEndDateRecOrder = moment(new Date().setDate(new Date().getDate() + 30)).format(FORMAT)
  if(recurrenceObjValues){
    requestStartDateRecOrder = moment(recurrenceObjValues.startDate).format(FORMAT)
    requestEndDateRecOrder = moment(recurrenceObjValues.endDate).format(FORMAT)
  }

    return {
        material: editResponse?.palletDetails?.material || "WOOD",
        condition0: condition0 || "",
        condition1: condition1 || "",
        condition2: condition2 || "",
        condition3:"",
        hardOrSoftWood: editResponse?.palletDetails?.newConditionType === 'SOFTWOOD' ? 'New - Softwood' :
          editResponse?.palletDetails?.newConditionType === 'HARDWOOD' ? 'New - Hardwood' : '',
        palletType:palletType || "BLOCK",
        moisture:editResponse?.palletDetails?.moisture || "",
        size: editResponse?.palletDetails?.size || "",
        grade: editResponse?.palletDetails?.grade || "",
        isHeatTreared: editResponse?.palletDetails?.heatTreared || false,
        poNumber:editResponse?.loadDetails?.palletDetails?.poNumber || "",
        lotsOption:editResponse?.loadDetails?.lotType || "MULTIPLE",

        companyName:"",
        businessName:"",       
        requestDeliveryDate:requestDeliveryDate,        
        appointment:editResponse?.loadDetails?.appointment || "DELIVERY_WINDOW",
        // deliveryWindowBegin:editResponse?.data?.deliveryFromTime?editResponse?.data?.deliveryFromTime: beginCurrentTime,
        // deliveryWindowEnd:editResponse?.data?.deliveryToTime?editResponse?.data?.deliveryToTime: endCurrentTime,
        appt:beginCurrentTime,
        apptTo:endCurrentTime,
        // addMoreArrList.[0].lots:"",
        equipment0:equipment0,
        equipment1:equipment1,
        equipment2:equipment2,
        apptEdit:editResponse?.loadDetails?.deliveryFromtime,
        apptToEdit:editResponse?.loadDetails?.deliveryTotime,
        lots:editResponse?.loadDetails?.quantityDetails?.lots || "",
        QuantityLot: editResponse?.loadDetails?.quantityDetails?.quantity || 540,
        originalQuantity:editResponse?.loadDetails?.quantityDetails?.originalQuantity || 540,
        length:editResponse?.palletDetails?.length || '',
        width:editResponse?.palletDetails?.width || '',
        height:editResponse?.palletDetails?.height || '',
        quantityMaxValue:editResponse?.loadDetails?.quantityDetails?.originalQuantity || 540,
        // TotalQuantity:editResponse?.data?.quantityDetails?.totalQuantity || "",
        
        // addMoreArrList:[],
        addMoreArrList:[{
          lots:editResponse?.loadDetails?.quantityDetails?.lots || "",
          QuantityLot:editResponse?.loadDetails?.quantityDetails?.quantity || 540,
          quantityMaxValue:editResponse?.loadDetails?.quantityDetails?.quantityMaxValue || 540,
          requestDeliveryDate: recurrenceObjValues ? requestStartDateRecOrder : loadDetailsRequestDeliveryDate ? loadDetailsRequestDeliveryDate : requestDeliveryDate,
          appt:beginCurrentTime,
          apptTo:endCurrentTime,
          poNumber:editResponse?.loadDetails?.poNumber || ""
        }],
        remark:editResponse?.remark || "",
        // friends: ["jared", "ian", "brent"],
        // friends: [{
        //     lots:"",
        //     QuantityLot:"",
        //     requestDeliveryDate:"",
        //     appt:"",
        //     poNumber:""
        //   }],

         // recurring order fields
            recurringCheckBoxFlag: recurrenceObjValues ? true : false,
            recType: recurrenceObjValues?.recType || 'WEEKLY',
            recStartDate: requestStartDateRecOrder,
            recEndDate: requestEndDateRecOrder,
            weeklyRecEvery: recurrenceObjValues?.pattern?.weekly?.recuringEvery || 1,
            weeklyRecDays: recurrenceObjValues?.pattern?.weekly?.weekdays || [],
            monthlyRecType: recurrenceObjValues?.pattern?.monthly?.monthlyType || 'DAY',
            monthlyDayTypeRecDay: recurrenceObjValues?.pattern?.monthly?.dayType?.recuringDay || 1,
            monthlyDayTypeRecEvery: recurrenceObjValues?.pattern?.monthly?.dayType?.recuringEvery ||  1,
            monthlyCustomeTypeStartDateOfWeek: recurrenceObjValues?.pattern?.monthly?.custom?.weekOfMonth ||  'FIRST',
            monthlyCustomeTypeStarWeektDayOfWeek: recurrenceObjValues?.pattern?.monthly?.custom?.reccuringWeek ||  'MONDAY',
            monthlyCustomeTypeRecEvery: recurrenceObjValues?.pattern?.monthly?.custom?.recuringEvery ||  1,
            // recc order temp values
            recTypeTemp: recurrenceObjValues?.recType || 'WEEKLY',
            recStartDateTemp: requestStartDateRecOrder,
            recEndDateTemp: requestEndDateRecOrder,
            weeklyRecEveryTemp: recurrenceObjValues?.pattern?.weekly?.recuringEvery || 1,
            weeklyRecDaysTemp: recurrenceObjValues?.pattern?.weekly?.weekdays || [],
            monthlyRecTypeTemp: recurrenceObjValues?.pattern?.monthly?.monthlyType || 'DAY',
            monthlyDayTypeRecDayTemp: recurrenceObjValues?.pattern?.monthly?.dayType?.recuringDay || 1,
            monthlyDayTypeRecEveryTemp: recurrenceObjValues?.pattern?.monthly?.dayType?.recuringEvery ||  1,
            monthlyCustomeTypeStartDateOfWeekTemp: recurrenceObjValues?.pattern?.monthly?.custom?.weekOfMonth ||  'FIRST',
            monthlyCustomeTypeStarWeektDayOfWeekTemp: recurrenceObjValues?.pattern?.monthly?.custom?.reccuringWeek ||  'MONDAY',
            monthlyCustomeTypeRecEveryTemp: recurrenceObjValues?.pattern?.monthly?.custom?.recuringEvery || 1,
      };
}
const VALIDATION_SCHEMA = () => {
    let schemaAttributes = {
      // material: Yup.string().trim().required("Material is required."),
      //palletType: Yup.string().trim().required("PalletType is required."),
      // moisture: Yup.string().trim().required("Moisture is required."),
      //size: Yup.string().trim().required("Size is required."),
      // grade: Yup.string().trim().required("Grade is required."),
    
      // lots: Yup.string().trim().required("Lots is required."),
      // QuantityLot: Yup.string().trim().required("Quantity Lot is required."),
      // TotalQuantity: Yup.string().trim().required("TotalQuantity is required."),

      // businessName: Yup.string().trim().required("BusinessName is required."),
      // poNumber: Yup.string().trim().required("PO Number is required."),
    }
    return Yup.object().shape(schemaAttributes);
}
export { VALIDATION_SCHEMA };